
export interface EncodeStatusInfo {
    id: number | undefined;
    entity: EnumEntity | undefined;
    value: string | undefined;
}

export enum EnumEntity {
    ADDRESS="indirizzo",
    APPLICATION_COMPONENT="componente applicativa",
    APPLICATION_FUNCTIONALITY="funzionalità applicativa",
    CITIZEN="persona fisica",
    LEGAL_ENTITY="persona giuridica",
    ROLE="ruolo",
    USER="account"
}